import Api from "./Api";
export default {
  getSitesGrid(companyId) {
    return Api().get(`/site_grid/${companyId}`);
  },
  getSites(companyId) {
    return Api(companyId).get(`/sites/${companyId}`);
  },
  exportSitesGrid(payload) {
    return Api().get(`/sites_export/${payload.companyId}/${payload.type}`);
  },
  addSite(payload) {
    return Api().post(`/sites`, payload);
  },
  editSite(payload) {
    return Api().put(`/site/${payload.id}`, payload);
  },
  deleteSite(payload) {
    return Api().delete(`/site/${payload.companyId}/${payload.id}`);
  },
  getStoresBySearch(payload) {
    return Api().get(
      `proxy/ai/company/${payload.companyId}/sites/search/similarity_with_trigram`,
      { params: payload.params }
    );
  },
  getSitesBySearch(payload) {
    return Api().get(`/getsitesbycompanyid/${payload.companyId}`, {
      params: payload.params,
    });
  },
  applySiteAndAreaConfig(payload) {
    return Api().post(`/apply-config-to-${payload.type}`, payload);
  },
  setSitePassord(payload) {
    return Api().post(`/set-site-password`, payload);
  },
};
